import type React from "react";

interface BackArrowIconProps {
  className?: string;
}

export const BackArrowIcon: React.FC<BackArrowIconProps> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
  >
    <path
      d="M1.56459 5.0034L5.78469 8.87939C5.92823 9.01123 5.99761 9.16504 5.99282 9.34082C5.98804 9.5166 5.91388 9.67041 5.77034 9.80225C5.62679 9.93408 5.45933 10 5.26794 10C5.07656 10 4.90909 9.93408 4.76555 9.80225L0.344498 5.75487C0.229665 5.6494 0.143541 5.53075 0.0861244 5.39891C0.0287081 5.26708 0 5.13524 0 5.0034C0 4.87157 0.0287081 4.73973 0.0861244 4.60789C0.143541 4.47606 0.229665 4.3574 0.344498 4.25194L4.76555 0.191375C4.90909 0.059539 5.07895 -0.00418191 5.27512 0.000212639C5.47129 0.00460718 5.64115 0.0727226 5.78469 0.204559C5.92823 0.336395 6 0.490204 6 0.665986C6 0.841768 5.92823 0.995577 5.78469 1.12741L1.56459 5.0034Z"
      fill="currentColor"
    />
  </svg>
);
